import React from 'react';
import { useCart } from '../contexts/CartContext';
import { useNavigate } from 'react-router-dom';
import { BottomNavigation } from '../components/BottomNavigation';

export default function Cart() {
  const { cartItems, loading, error, updateCartItem, removeCartItem } = useCart();
  const navigate = useNavigate();

  // Cart items received and processed







  // Early return for loading
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-1 flex items-center justify-center text-neutral-500">Loading…</div>
        <BottomNavigation />
      </div>
    );
  }

  // Early return for error
  if (error) {
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-1 flex items-center justify-center text-red-500 mb-24">{error}</div>
        <BottomNavigation />
      </div>
    );
  }

  // Early return for empty cart
  if (cartItems.length === 0) {
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-1 flex items-center justify-center text-neutral-500 mb-24">Your cart is empty</div>
        <BottomNavigation />
      </div>
    );
  }

  // Cost calculations
  const subtotal = cartItems.reduce((sum, item) => {
    const price = Number(item.price) || 0;
    const qty = Number(item.qty) || 0;
    return sum + price * qty;
  }, 0);
  const serviceFee = subtotal > 0 ? 2.0 : 0;
  const tax = subtotal > 0 ? +(subtotal * 0.08).toFixed(2) : 0;
  const total = subtotal + serviceFee + tax;

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col items-center py-8 font-montserrat px-4">
      {/* Header */}
      <header className="w-full max-w-md flex items-center mb-6">
      </header>

      {/* Item List */}
      <main className="w-full max-w-md flex-1 overflow-y-auto pb-32">
        <div className="space-y-4">
          {cartItems.map(item => (
            <div key={item.id} className="flex items-center bg-white rounded-xl shadow p-4 gap-4">
              <img src={item.imageUrl || item.image || '/default-product.png'} alt={item.name} className="w-16 h-16 rounded object-cover border" />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm truncate">{item.name}</div>
                {item.variant && Object.keys(item.variant).length > 0 && (
                  <div className="text-xs text-neutral-500 truncate">
                    {Object.entries(item.variant).map(([key, value]) => `${key}: ${value}`).join(', ')}
                  </div>
                )}
                <div className="text-xs text-neutral-500 truncate">{item.attributes}</div>
                <div className="font-bold text-sm mt-1">${(Number(item.price) || 0).toFixed(2)}</div>
              </div>
              <div className="flex flex-col items-center gap-2">
                <div className="flex items-center gap-1">
                  {item.qty > 1 ? (
                    <button
                      className="w-8 h-8 flex items-center justify-center rounded bg-neutral-100 px-0 py-0"
                      onClick={() => updateCartItem(item.id, item.qty - 1)}
                      aria-label="Decrease quantity"
                    >-</button>
                  ) : (
                    <button
                      className="w-8 h-8 flex items-center justify-center rounded bg-neutral-100 px-0 py-0"
                      aria-label="Remove product"
                      onClick={() => removeCartItem(item.id)}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 6h18" />
                        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                        <line x1="10" y1="11" x2="10" y2="17" />
                        <line x1="14" y1="11" x2="14" y2="17" />
                      </svg>
                    </button>
                  )}
                  <span className="mx-2 w-4 text-center">{item.qty}</span>
                  <button
                    className="w-8 h-8 flex items-center justify-center rounded bg-neutral-100 px-0 py-0"
                    onClick={() => updateCartItem(item.id, item.qty + 1)}
                    aria-label="Increase quantity"
                  >+
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* Cost Summary (above bottom nav) */}
      <footer className="w-full max-w-md bg-white border-t shadow-lg p-6 space-y-3 z-10 mb-8 mx-4">
        <div className="flex justify-between text-sm">
          <span>Subtotal</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span>Service Fee</span>
          <span>{serviceFee > 0 ? `$${serviceFee.toFixed(2)}` : 'Free'}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span>Tax</span>
          <span>${tax.toFixed(2)}</span>
        </div>
        <div className="flex justify-between font-bold text-base border-t pt-2">
          <span>Total</span>
          <span>${total.toFixed(2)}</span>
        </div>
        <button
          className="w-full py-4 rounded-lg bg-gradient-to-r from-[#C97B53] to-[#E89B5A] text-white font-bold text-sm mt-2 disabled:opacity-60"
          disabled={cartItems.length === 0}
          onClick={() => navigate('/checkout')}
        >
          Proceed to Checkout
        </button>
      </footer>
      <BottomNavigation />
    </div>
  );
} 